import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID, 
};

const app = initializeApp(firebaseConfig);

const firebaseAuthConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_AUTH_API_KEY || process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_AUTH_DOMAIN || process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_AUTH_PROJECT_ID || process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_AUTH_STORAGE_BUCKET || process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_AUTH_MESSAGING_SENDER_ID || process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_AUTH_APP_ID || process.env.REACT_APP_FIREBASE_APP_ID,
};

const authApp = initializeApp(firebaseAuthConfig, 'help2fix-auth');

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export const auth = getAuth(authApp);

let categoriesTranslationsPromise;

export const getCategoriesTranslations = async () => {
  if (!categoriesTranslationsPromise) {
    const docRef = doc(db, "translations", "categories");
    categoriesTranslationsPromise = getDoc(docRef)
      .then(docSnap => docSnap.data() || { input: [], translated: [] })
      .catch(error => {
        categoriesTranslationsPromise = undefined;
        throw error;
      });
  }

  return categoriesTranslationsPromise;
};

export const fireCategoriesTr = async (setTrCategoriesArr) => {
  setTrCategoriesArr(await getCategoriesTranslations());
}

export const fireDescriptionsTr = async (setDescriptionsArr) => {
  const docRef = doc(db, "translations", "descriptions");
  const docSnap = await getDoc(docRef);
  const trDescriptions = docSnap.data();

  setDescriptionsArr(trDescriptions.translated);
}

export const fireSingleCategory = async (category, lang, setTranslatedCategory) => {
  const docRef = doc(db, "translations", "categories");
  const docSnap = await getDoc(docRef);
  const trCategories = docSnap.data();
  let index = trCategories?.input?.indexOf(category);

  const trCategory = trCategories.translated[index][lang];

  setTranslatedCategory(trCategory);
}
